/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

/*
 * This util is used to provide internationalization for non-react components.
 * Recommended for action handlers' console notification internationalization
 */
import { createIntl, createIntlCache } from 'react-intl';

const language =
  (navigator.languages && navigator.languages[0]) || navigator.language;
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
const locale = languageWithoutRegionCode || language;

let messages = {};

// load locale unless the language is en
if (locale !== 'en') {
  try {
    // todo update /lang directory location
    // eslint-disable-next-line import/no-dynamic-require, global-require
    messages = require(`lang/${locale}.json`);
  } catch {
    // eslint-disable-next-line no-console
    console.warn(
      `Specified lang file: ${locale}.json is not found. Default language (English) will be displayed.`
    );
  }
}

const cache = createIntlCache(); // needed to prevent memory leaks
const intl = createIntl({ locale, messages }, cache);

export default intl;
